var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-table',{attrs:{"columns":_vm.columns,"rows":_vm.groups},scopedSlots:_vm._u([{key:"roles",fn:function(ref){
var value = ref.value;
return [_vm._v(_vm._s(value.length)+" Roles")]}},{key:"permissions",fn:function(ref){
var value = ref.value;
return [_vm._v(_vm._s(value.length)+" Permissions")]}},{key:"actions",fn:function(ref){
var row = ref.row;
return [_c('ui-link',{on:{"click":function($event){return _vm.$emit('edit-click', row)}}},[_vm._v("Bearbeiten")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }